var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputAddress',{attrs:{"db-override":_vm.db,"question-override":_vm.question,"jsErrorsData":_vm.jsErrors,"noSave":true,"errors-post":_vm.errorsPost},on:{"jsErrors":function($event){_vm.jsErrors=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }